import type { FC, Ref } from "react";
import { Chip, Flex, Heading, Text, useFormattedDate } from "@huub-web/ui";

export interface AnalysisHeadingProps {
  generatedAt?: string;
  title: string;
  description?: string;
}

/**
 * @deprecated
 */
export const AnalysisHeading: FC<
  AnalysisHeadingProps & { ref?: Ref<HTMLDivElement> }
> = ({ generatedAt, title, description, ref }) => {
  const { formatDate } = useFormattedDate();

  return (
    <>
      <Heading
        ref={ref}
        variant="main"
        title={title}
        description={description}
      />
      {generatedAt && (
        <Flex gap="xxs" align="center" direction="column">
          <Chip variant="tertiary" size="l">
            <Text variant="bodyM" color="currentColor50" as="span">
              Geanalyseerd op{" "}
            </Text>
            {formatDate(generatedAt, { format: "dayMonthYear" })}
            <Text variant="bodyM" color="currentColor50" as="span">
              {" "}
              om{" "}
            </Text>
            {formatDate(generatedAt, { format: "minutesHours" })}
          </Chip>
        </Flex>
      )}
    </>
  );
};
